import _typeof from '@babel/runtime/helpers/typeof';

var isFunction = function isFunction(value) {
  return value instanceof Function;
};
var isString = function isString(value) {
  return typeof value === 'string';
};
var isArray = function isArray(value) {
  return (
    Boolean(value) && _typeof(value) === 'object' && (value === null || value === void 0 ? void 0 : value.constructor) === Array
  );
};

export { isArray, isFunction, isString };
//# sourceMappingURL=check-type.js.map
